import { Spinner, styled } from '@volkswagen-onehub/components-core';
import React, { useContext } from 'react';
import LocalDealer from '../../../components/LocalDealer';
import { getTranslations } from '../../../translations';
import { VehicleDetailsContext } from '../../../utils/details-context';
import BuildPriceFieldset from '../BuildPriceFieldset';

export const LocalDealerContainer = styled.div``;

const YourLocalDealer = () => {
  const context = useContext(VehicleDetailsContext);
  const vehicle = context.vehicle;
  const dealer = context.dealer;
  const { labels } = getTranslations();

    return vehicle && dealer ? (
        <LocalDealerContainer>
            <BuildPriceFieldset legend={labels.your_local_dealer} headline=''>
                <LocalDealer dealer={dealer} showAction={true} />
            </BuildPriceFieldset>
        </LocalDealerContainer>
    ) : <Spinner />
}

export default YourLocalDealer;
